import { useQuery } from '@tanstack/react-query';
import { ORG_MANAGEMENT_QUERY_KEYS } from 'app/modules/orgManagement/queries/keys';
import { get } from 'app/shared/utils/fetchr';
import { SessionAgent } from 'app/modules/session/models';
import { selectHasAdminAPIPermission } from 'app/modules/session/selectors';
import { useSelector } from 'react-redux';

export const useGetOrgAgents = (orgID: number = -1) => {
  const hasAdminAPIPermission = useSelector(selectHasAdminAPIPermission);
  return useQuery({
    queryKey: ORG_MANAGEMENT_QUERY_KEYS.getOrgAgents(orgID),
    queryFn: () => {
      return get<SessionAgent[]>(`/v1/orgs/${orgID}/agents`);
    },
    enabled: hasAdminAPIPermission && orgID > 0,
  });
};
